import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {
	initIntervistaState,
	INTERVISTA_INITIAL_STATE,
	IntervistaReducer
} from "../../../../../reducers/IntervistaReducer";
import {useHistory, useParams} from "react-router-dom";
import {
	Backdrop,
	Card, CardActions,
	CardContent,
	CardHeader,
	CircularProgress,
	Container,
	Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {useForm, FormProvider} from "react-hook-form";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import {InfoLavorativeGrid} from "../content/InfoLavorativeGrid";
import {SintomiGrid} from "../content/SintomiGrid";
import {MedicoGrid} from "../content/MedicoGrid";
import {RischioGrid} from "../content/RischioGrid";
import {getIntervistaApiData} from "../../../../../services/utils/IntervistaApiData";
import {generateIntervista} from "../../../../../services/IntervistaServices";
import {bigNoteRegisterNotRequired} from "../../../../../utils/RegisterUtils";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import {TitleUtils} from "./TitleUtils";
import {AnagraficaContext, AppContext} from "../../../../../App";
import {getAnagraficaById} from "../../../../../services/AnagraficaServices";
import HideAppBar from "../../../../widgets/header/HideAppBar";
import {setOpenSnackbar} from "../../../../../services/AppServices";

const CreaIntervistaBase = () => {
	const classes = BaseStyle();
	let history = useHistory();
	const [state, dispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const [submit, setSubmit] = useState(false);
	let {idSoggetto} = useParams();
	const [value1, setValue1] = React.useState(null);
	const [inputValue1, setInputValue1] = React.useState("");
	const methods = useForm({mode: "onChange"});
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		generateIntervista(getIntervistaApiData({...data, soggetto: anagraficaContext.state.anagrafica}), dispatch);
	}, [dispatch, anagraficaContext.state.anagrafica]);
	
	useEffect(() => {
		if (submit && !state.loadingAddIntervista && state.errorAddIntervista === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Intervista creata correttamente. Ora verrai rimandato alla pagina del paziente...", appContext.dispatch)
			setTimeout(() => {
				history.push("/gestione/pazienti/" + idSoggetto);
			}, 2000);
		} else if (submit && !state.loadingAddIntervista && state.errorAddIntervista !== "") {
			setSubmit(false);
			setOpenSnackbar("success", state.errorAddIntervista, appContext.dispatch)
		}
	}, [submit, state.loadingAddIntervista, state.errorAddIntervista, history, idSoggetto, appContext.dispatch])
	
	useEffect(() => {
		getAnagraficaById(idSoggetto, anagraficaContext.dispatch);
	}, [idSoggetto, anagraficaContext.dispatch])
	
	return (
		<React.Fragment>
			<Backdrop open={submit} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			<main className={classes.main}>
				<HideAppBar title={"Crea intervista"} back={true}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Card className={classes.roundBorder}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardHeader
									title={<Typography variant={"h4"}><b>Intervista paziente</b></Typography>}
									subheader={<Typography variant={"subtitle1"} color={"textSecondary"} style={{marginTop: 24}}>
										Compila il form intervista per creare un'intervista a prescindere dal tampone. L'intervista finirà
										nel contenitore "Gestione interviste" e da lì potrai decidere di aggiungere un'
										autosorveglianza/isolamento e di aggiungere in seguito i contatti se necessario.<br/>
										Se vuoi solamente aggiungere delle relazioni tra dei pazienti senza necessariamente intervistarli
										e/o creare un'ordinanza puoi utilizzare la sezione "Relazioni pazienti" all'interno del menù della
										pagina del paziente.
									</Typography>}
								/>
								<CardContent style={{flexGrow: 1}}>
									<FormProvider {...methods}>
										<form onSubmit={methods.handleSubmit(onSubmit)}>
											<Grid container spacing={3}>
												
												<TitleUtils title={"Informazioni di carattere socio-lavorativo"} num={1} bottomDiv={true}
												            topDiv={false}/>
												<InfoLavorativeGrid value={value1} inputValue={inputValue1} setValue={setValue1}
												                    setInputValue={setInputValue1}/>
												
												<TitleUtils title={"Medico di medicina generale"} num={2} bottomDiv={true}
												            topDiv={true}/>
												<MedicoGrid note={false}/>
												
												<TitleUtils title={"Sintomi e patologie"} num={3} bottomDiv={true}
												            topDiv={true}/>
												<SintomiGrid/>
												
												<TitleUtils title={"Rischio e contagio"} num={4} bottomDiv={true}
												            topDiv={true}/>
												<RischioGrid/>
												
												<TitleUtils title={"Note"} num={5} bottomDiv={true}
												            topDiv={true}/>
												<Grid item xs={12}>
													<CustomMultiText
														inputRef={methods.register(bigNoteRegisterNotRequired)}
														name={"note"}
														label={"Note aggiuntive"}
														autoFocus={false}
														error={methods.errors["note"]}
													/>
												</Grid>
											
											</Grid>
										</form>
									</FormProvider>
								</CardContent>
								<CardActions className={classes.flexRight}>
									<Tooltip
										title={"Conferma i dati indicati nel form"}>
										<Button variant={"contained"} disableElevation color="primary" disabled={submit}
										        style={{borderRadius: 24}}
										        className={classes.roundButton} onClick={methods.handleSubmit(onSubmit)}>
											<b>Conferma ed invia</b>
										</Button>
									</Tooltip>
								</CardActions>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
		
		</React.Fragment>
	)
		;
};

export default React.memo(CreaIntervistaBase)
